import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Drawer,
    Grid,
    IconButton,
    Snackbar,
    Tab,
    Tabs,
    Typography,
    MenuItem,
    Select,
    TextField,
    Badge,
    Avatar,
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio
} from "@mui/material";
import { S3_URL } from "../config";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import React, { useEffect, useState } from 'react';
import ShoppingBagIcon from '../images/shoppingbag.png';
import { resolvePath, useLocation } from 'react-router-dom';
import axiosInstance from "../axiosConfig";
import SubscriptionDialog from "./SubscriptionDialog";

export default function CurrySubscription() {
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0);
    const [cart, setCart] = useState({});
    const [cartOpen, setCartOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
    const [selectedBoxContent, setSelectedBoxContent] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tab = parseInt(queryParams.get('tab'), 10);
        if (!isNaN(tab)) {
            setTabIndex(tab);
        }
    }, [location]);

    const handleAddToCart = (title, price, id, contents) => {
        setCart((prevCart) => ({
            ...prevCart,
            [title]: {
                quantity: (prevCart[title]?.quantity || 0) + 1,
                price,
                id,
                contents
            }
        }));
    };

    const handleRemoveFromCart = (title) => {
        setCart((prevCart) => {
            const newCart = { ...prevCart };
            if (newCart[title]?.quantity > 1) {
                newCart[title].quantity -= 1;
            } else {
                delete newCart[title];
            }
            return newCart;
        });
    };

    const handleOpenDialog = (content) => {
        setSelectedBoxContent(content);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleCartOpen = () => setCartOpen(true);
    const handleCartClose = () => setCartOpen(false);

    const handleCartDialogOpen = (item) => {
        setSelectedItem(item);
        setOpenSubscriptionDialog(true);
    };

    const handlePreOrder = () => {
        console.log('Cart:', cart);
    };

    const totalPrice = Object.values(cart).reduce((sum, item) => sum + (item.quantity * parseFloat(item.price)), 0);
    const totalItems = Object.values(cart).reduce((sum, item) => sum + item.quantity, 0);

    return (
        <Box sx={{ width: "100%", padding: 2, marginTop: '64px' }}>
            {/* Responsive Tabs */}
            <Box sx={{ display: { xs: 'none', md: 'block' }, borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabIndex} onChange={(e, value) => setTabIndex(value)}>
                    <Tab label="Meal Plan" icon={<DinnerDiningIcon />} />
                </Tabs>
            </Box>

            {/* Floating Tabs for Mobile */}
            <Box sx={{ position: 'fixed', top: '50%', right: 16, zIndex: 1000, display: { xs: 'flex', md: 'none' }, flexDirection: 'column', gap: 1 }}>
                <Fab size="small" color={tabIndex === 0 ? "primary" : "default"} onClick={() => setTabIndex(0)}>
                    <DinnerDiningIcon />
                </Fab>
            </Box>

            <Box sx={{ marginTop: 2 }}>
                {tabIndex === 0 && (
                    <ProductBox
                        cart={cart}
                        onAdd={handleAddToCart}
                        onRemove={handleRemoveFromCart}
                        onOpenDialog={handleOpenDialog}
                        category="curries"
                        title="Homemade Curries, Zero Hassle! Subscribe"
                        onSubscribe={handleCartDialogOpen}
                    />
                )}
            </Box>

           {openSubscriptionDialog && selectedItem && (
                <SubscriptionDialog
                    open={true}
                    onClose={() => setOpenSubscriptionDialog(false)}
                    cart={cart}
                    setCart={setCart}
                    totalPrice={totalPrice}
                    handlePreOrder={handlePreOrder}
                    item={selectedItem}
                />
            )}
       </Box>
    );
}

// ----------------------------------
// ProductBox Component
// ----------------------------------

const ProductBox = ({ cart, onAdd, onRemove, onOpenDialog, category, title, onSubscribe }) => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        axiosInstance.get(`/preorderbox/category/${category}`).then(response => setProducts(response.data));
    }, [category]);

    return (
        <Container>
            <Typography variant="h4" gutterBottom align="center" sx={{
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                [theme => theme.breakpoints.down('sm')]: {
                    fontSize: '1.5rem'
                }
            }}>
                {title}
            </Typography>

            <Grid container spacing={4} justifyContent="center">
                {products.map((item, index) => (
                    <Grid item key={index} xs={12} sm={6} md={3}>
                        <Card sx={{ borderRadius: '24px', boxShadow: 3, height: '480px', maxWidth: '275px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                            <CardMedia
                                component="img"
                                height="180"
                                image={`${S3_URL}${item.image}`}
                                alt={item.title}
                                sx={{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }}
                            />
                            <CardContent sx={{ padding: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
                                <Typography variant="h5" gutterBottom>
                                    {item.title}
                                    <Typography variant="h6" color="primary">${item.price}</Typography>
                                </Typography>
                                <Typography variant="body2" gutterBottom>{item.description}</Typography>
                                {item.contents?.split(',').map((contentItem, contentIndex) => (
                                    <Typography key={contentIndex} sx={{ marginBottom: 1 }}>
                                        • {contentItem.trim()}
                                    </Typography>
                                ))}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => onSubscribe(item)}
                                    sx={{
                                        marginTop: 'auto',
                                        position: 'absolute',
                                        bottom: 8,
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        borderRadius: '20px',
                                        paddingX: 4,
                                    }}
                                >
                                    Subscribe
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};
